import { Dialog } from 'radix-ui';
import styled from 'styled-components';

export const DialogOverlay = styled(Dialog.Overlay)(({ theme }) => ({
  background: theme.colors.overlay,
  position: 'fixed',
  inset: 0,
}));

export const DialogContentPositioner = styled(Dialog.Content)(({ theme }) => ({
  position: 'fixed',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'flex',
    width: 'unset',
    height: 'unset',
  },
}));

export const DialogTrigger = styled(Dialog.Trigger)({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  height: 'fit-content',
});
